require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.4@core-js/library/fn/object/define-property.js
// module id = 249
// module chunks = 0 1